import React, { useContext } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import CustomerModal from "./ItemModal/CustomerModal";
import { Button } from "react-bootstrap";
import { OrderPrint } from "./OrderPrint";
import PasscodeAuthenticator from "../PasscodeAuthenticator/PasscodeAuthenticator";
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { TiArrowSortedDown } from "react-icons/ti";
import CallCenterModal from "./ItemModal/CallCenterModal";
import CallCenterOrdertype from "./ItemModal/CallCenterOrdertype";
import "react-datepicker/dist/react-datepicker.css";
//functions
import {
  _t,
  currencySymbolLeft,
  currencySymbolRight,
  getSystemSettings,
  checkPermission,
  // restaurantMenuLink,
} from "../../../../../functions/Functions";
// custom styles
import "./NewPos.css";

import { NavLink } from "react-router-dom";
import SettleOrder from "./settleOrder/SettleOrder";
import {
  calculatePriceForCartItem
} from "./helpers";
import CartItem from "./CartItem";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import PosModal from "./ItemModal/PosModal";
import CustomPosModal from "./ItemModal/CustomPosModal";
import InstructionModal from "./ItemModal/InstructionModal";
import usePosLogics from "./hooks/usePosLogics";
import CategoryMenu from "./CategoryMenu";
import MenuHeader from "./CategoryGrid";
import ItemListing from "./ItemListing";
// import { FaLock, FaTable, FaUnlock, FaUtensils } from "react-icons/fa6";
// import { FaLock, FaUnlock, } from "react-icons/fa";
import OrderTypeModal from "./OrderType";
import ItemModal from "../newpos/ItemModal/ItemModal";
import NewTableModal from "./ItemModal/NewTableModal";
import { FaConciergeBell, FaLock, FaUnlock, FaUserEdit } from "react-icons/fa";
import RunningOrderModal from "./ItemModal/RunningOrderModal";
import POSCardDropdown from "./ItemModal/POSCardDropdown";
import { FoodContext } from "../../../../../contexts/Food";

gsap.registerPlugin(MotionPathPlugin);

function NewPos() {
  const {
    t,
    showSettle,
    buttonDisabled,
    availableDeptTags,
    selectedDeptTag,
    handleDeptTag,
    handleSearch,
    searchInput,
    inputSearch,
    activeFoodGroup,
    handleFoodGroup,
    availableFoodGroups,
    orderCounter,
    onlineOrder,
    availableDeliveryTypes,
    selectedDeliveryType,
    selectedParty,
    handleDeliveryType,
    handleSelectedParty,
    runningOrders,
    editOrder,
    authUserInfo,
    modal9Show,
    setModal9Show,
    modalOrderType,
    setModalOrderType,
    setOrderDetails,
    orderDetails,
    newSettings,
    generalSettings,
    handleSetBranch,
    zoneArea,
    setZoneArea,
    area,
    setArea,
    setDeliveryCharges,
    selectedBranch,
    setEditOrder,
    setModal10Show,
    taxHeight,
    setItemImage,
    itemImage,
    selectTable,
    setSelectTable,
    tableId,
    selectedKot,
    setSelectedKot,
    setShowSettle,
    setButtonDisabled,
    discountInput,
    cartSubTotal,
    calculateTax,
    isLocked,
    authenticateStaffUser,
    onSuccessAuthenticationStaff,
    showPasswordPopup,
    hanleCancelAuthenticate,
    handleCardSubmit,
    cardModal,
    order_id,
    availableDeliveryParties,
    managerId,
    cartItems,
    setCartItems,
    cartTotal,
    deliveryCharges,
    roundOffPrice,
    getBeforeTaxPrice,
    theVatSettle,
    setTheVatSettle,
    setPaidMoney,
    setNewSettings,
    totalsettle,
    setTotalSettle,
    paidMoney,
    serviceCharges,
    foodItem,
    setFoodItem,
    loyaltyPoint,
    setloyaltyPoint,
    emptyCardOnChange,
    tokenNumber,
    theVat,
    theTax,
    setTheVat,
    returnMoneyUsd,
    setReturnMoneyUsd,
    isSettle,
    handleLocalPrint,
    handleReceiptPrint,
    handleKotItems,
    paymentTypeAvailable,
    fbrInvoiceNum,
    srbInvoiceNum,
    token_No,
    newOrder,
    foodGroupsToPrint,
    con_Kot,
    taxType,
    component2Ref,
    barcodePrintRef,
    managerPasscode,
    setComponentUnlock,
    setManagerId,
    componentUnlock,
    backModal,
    setBackModal,
    emptyCard,
    cashDetails,
    setCashDetails,
    noteRiderModal,
    setNoteRiderModal,
    handlePreOrder,
    addReasonOnSubmit,
    setAddReasonModalShowing,
    addFocItem,
    setAddFocItem,
    handleFocItem,
    addReasonModalShowing,
    deleteReason,
    setDeleteReason,
    setPaymentTypeModalState,
    paymentTypeModalState,
    callCenterPayment,
    setCallCenterPayment,
    workPeriodScreen,
    branchForSearch,
    searchedFoodItem,
    flyStart,
    animate,
    handleFoodItemClicked,
    handleCloseItemModal,
    menuWisePrice,
    showModal,
    selectedFoodItem,
    selectedFoodItemId,
    addToCart,
    cardAnimate,
    deleteCartItem,
    editCartItem,
    deleteOneCartItem,
    commentFocus,
    handleSetItemQty,
    handleSetItemPrice,
    handleSetItemDiscount,
    deletedItemsOnEdit,
    setCommentId,
    userLock,
    itemAdd,
    modal10Show,
    setTableId,
    guestSelected,
    setGuestSelected,
    commentId,
    updateItemImage,
    updateComments,
    taxScroll,
    handleTaxOnPaymentTypeChange,
    deliveryInput,
    hanldeDiscountPercent,
    toastObj,
    tempSchemeForSearch,
    schemeForSearchObj,
    handleSetOffer,
    paymentOptions,
    currentNavPill,
    handlePaymentType,
    loading,
    handleSubmitOrder,
    handlePreOrderConfirmation,
    syncOrder, 
    syncLocalOrders,
    handleSettleOrderButton,
    handleFocConfirmation,
    componentRef,
    setShowordertypeModal,
    showordertypeModal,
    setExpanded,
    expanded,
    setCatInOneLine,
    CatInOneLine,
    handlePunchOrder
  } = usePosLogics();

  const { menuForPos } = useContext(FoodContext);

  const isMenuAvailable = !!((Object.keys(menuForPos)?.length) && orderDetails?.branch &&
    selectedDeptTag && activeFoodGroup && menuForPos[orderDetails.branch.id] &&
    menuForPos[orderDetails.branch.id][selectedDeptTag.id] &&
    menuForPos[orderDetails.branch.id][selectedDeptTag.id][activeFoodGroup]);

  return (
    <>
      <div
        className={`pos--main-container new---pos--container bg-white row m-0 p-0
        ${!showSettle ? "" : "d-none"}
      `}
      >
        <div className={`${(buttonDisabled) && "loadingBlur"}`}></div>
        <div className={`${(buttonDisabled) && "lds-roller"}`}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        {/* main content */}
        <div className="col-12  mt-0 main-container-pos-wrapper px-0">
          <div className="d-flex justify-content-between align-items-center top-header-pos-wrapper">
            <div className="col mr-2 ml-3  branch-select-container">
              <Select
                options={availableDeptTags || []}
                getOptionLabel={(a) => a.name}
                getOptionValue={(a) => a.name}
                value={selectedDeptTag}
                onChange={(e) => {
                  if (order_id) {
                    toast.error(
                      "Can't change order type/party on edit complete the current order"
                    );
                  } else {
                    handleDeptTag(e);
                  }
                }}
                classNamePrefix="Menu"
                className="table-text"
                maxMenuHeight="200px"
                placeholder="Select Menu"
                styles={{
                  indicatorSeparator: (provided) => ({
                    ...provided,
                    display: "none",
                  }),
                  control: (provided) => ({
                    ...provided,
                    borderRadius: ".5rem",
                    borderColor: "#27ccaa",
                    maxHeight: "2rem",
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    color: "#27ccaa",
                  }),
                }}
              />
            </div>
            <div className="pos--options-container  col">
              {
                authUserInfo.details?.order_type_id && typeof (authUserInfo.details.order_type_id) === "string" ?
                  onlineOrder.current && (
                    <NavLink
                      className="pos--btn btn mr-2 btn-min online-order bg-primary text-white"
                      to={"/dashboard/pos/online-orders"}
                    >
                      <img src={'/assets/img/online-order-shortcut-icon.svg'} alt="layout" style={{ width: "19px", height: "18px" }} />
                      <span className="d-flex align-items-center">
                        Online Ord.
                      </span>
                      {orderCounter?.online > 0 && (
                        <span className=" rounded-md special-category">
                          ({orderCounter.online})
                        </span>
                      )}
                    </NavLink>
                  ) :
                  (
                    <NavLink
                      className="pos--btn btn btn-min online-order with-count-ord mr-2 bg-success text-white"
                      to={"/dashboard/pos/online-orders"}
                    >
                      <img src={'/assets/img/online-order-shortcut-icon.svg'} alt="online-order" style={{ width: "20px", height: "19px" }} />
                      <span className="d-flex align-items-center">
                        Online Ord.
                        <span className=" rounded-md special-category">
                          ({orderCounter.online ? orderCounter.online : 24})
                        </span>
                      </span>
                    </NavLink>
                  )
              }
              {authUserInfo.details.user_type !== "call_center" && (
                <>
                  {authUserInfo.details.user_type !== "waiter" && (
                    <NavLink
                      className="pos--btn sattled--btn btn  btn-min mr-2 bg-success  text-white"
                      to={"/dashboard/pos/settled"}
                    >
                      <img src={'/assets/img/settled-order-shortcut-icon.svg'} alt="layout" style={{ width: "19px", height: "17px" }} />
                      <span className="d-flex align-items-center">
                        Settled Ord.
                      </span>
                    </NavLink>
                  )}

                  <div className="btn-group mr-2 ">
                    <NavLink
                      className={`dropdwn--btn  Running-odr  btn-min btn text-white bg-success text-decoration-none ${runningOrders && runningOrders?.length > 0
                        ? ""
                        : "rounded-05 not-runn"
                        }`}
                      to={"/dashboard/pos/submitted"}
                      style={{ marginRight: runningOrders && runningOrders?.length > 0 ? "-3px" : 0, }}
                    >
                      <span className="d-flex align-items-center">
                        Running Odr.
                      </span>
                      {orderCounter?.ready > 0 && (
                        <span className=" rounded-md special-category">
                          ({orderCounter.ready})
                        </span>
                      )}
                    </NavLink>
                    {runningOrders && runningOrders?.length > 0 && (
                      <button
                        data-ignore="true"
                        className="dropdwn1--btn  btn bg-success text-white"
                        onClick={() => setEditOrder(!editOrder)}
                        style={{ marginLeft: "-4px", borderLeft: "unset" }}
                      >
                        <i data-ignore="true" className="fa-sharp fa fa-caret-down lg-text" style={{ marginTop: "7px" }} />
                      </button>
                    )}
                    {editOrder && (
                      <RunningOrderModal setEditOrder={setEditOrder} editOrder={editOrder}/>
                    )}
                  </div>
                </>
              )}
              {
                authUserInfo.details.user_type === "call_center" && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 ? (
                  <>
                    <CallCenterModal
                      show={modal9Show}
                      onHide={() => setModal9Show(false)}
                      modal9Show={modal9Show}
                      setModal9Show={setModal9Show}
                      setModalOrderType={setModalOrderType}
                      setOrderDetails={setOrderDetails}
                      orderDetails={orderDetails}
                      selectedParty={selectedParty}
                      checkDelivery={selectedDeliveryType && selectedDeliveryType?.name.toLowerCase() === "delivery"}
                      newSettings={newSettings}
                      handleSetBranch={handleSetBranch}
                      zoneArea={zoneArea}
                      setZoneArea={setZoneArea}
                      area={area}
                      setArea={setArea}
                      setDeliveryCharges={setDeliveryCharges}
                      selectedBranch={selectedBranch}
                      workPeriodScreen={workPeriodScreen}
                    />
                    <CallCenterOrdertype
                      show={modalOrderType}
                      onHide={() => setModalOrderType(false)}
                      modalOrderType={modalOrderType}
                      setModalOrderType={setModalOrderType}
                      setModal9Show={setModal9Show}
                      selectedParty={selectedParty}
                      selectedDeliveryType={selectedDeliveryType}
                      availableDeliveryTypes={availableDeliveryTypes}
                      handleDeliveryType={handleDeliveryType}
                      handleSelectedParty={handleSelectedParty}
                      availableDeliveryParties={availableDeliveryParties}
                    />
                  </>

                ) : (
                  <CustomerModal
                    show={modal9Show}
                    onHide={() => setModal9Show(false)}
                    modal9Show={modal9Show}
                    setModal9Show={setModal9Show}
                    setOrderDetails={setOrderDetails}
                    orderDetails={orderDetails}
                    selectedParty={selectedParty}
                    checkDelivery={selectedDeliveryType && selectedDeliveryType?.name.toLowerCase() === "delivery"}
                    newSettings={newSettings}
                  />
                )
              }

              <Button
                className="pos--btn btn bg2-success xlg-text pos--icon-btn text-white border-0 mr-2"
                onClick={() =>
                  selectedParty
                    ? setModal9Show(true)
                    : toast.error("Please select party type")
                }
                disabled={(parseInt(getSystemSettings(generalSettings, "online_order_edit")) === 1 &&
                  selectedParty?.name === "Website" && orderDetails?.is_edit)}
              >
                <FaUserEdit className="new-btn" />
              </Button>
              {authUserInfo.details.user_type !== "call_center" && (
                <>
                  {parseInt(
                    getSystemSettings(generalSettings, "table_waiter")
                  ) === 1 ? (
                    selectedDeliveryType &&
                      selectedDeliveryType.name.match(/dine(.*)in/i) &&
                      parseInt(
                        getSystemSettings(generalSettings, "table_waiter")
                      ) === 1 ? (
                      <Button
                        className="pos--btn btn mr-2 bg2-success xlg-text pos--icon-btn text-white border-0 pl-0 dn-card"
                        onClick={() =>
                          selectedDeliveryType &&
                            selectedDeliveryType.name.match(/dine(.*)in/i)
                            ? setModal10Show(true)
                            : toast.error("Please select Dine In ")
                        }
                      >
                        <FaConciergeBell className="fa-address-card new-btn" />
                      </Button>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}
                </>
              )}
              {
                parseInt(getSystemSettings(generalSettings, "foodPanda_integration")) === 1 && authUserInfo.details.user_type !== "waiter" && (
                  <NavLink
                    ref={taxHeight}
                    className="btn foodPanda-btn btn-min text-white mr-2"
                    to={"/dashboard/pos/foodpanda"}
                  >
                    <img src={'/assets/img/foodpanda-party-icon.svg'} alt="foodpanda" style={{ width: "30px", height: "29px" }} />
                    <span className="d-flex align-items-center">
                      Food Panda
                    </span>
                    {orderCounter.foodPanda > 0 && (
                      <span className=" pl-1 rounded-md special-category">
                        ({orderCounter.foodPanda})
                      </span>
                    )}
                  </NavLink>
                )
              }

              <button type="button" class="btn btn-primary btn-order-type btn-min mr-2" onClick={() => setShowordertypeModal(!showordertypeModal)}>
                <span className="d-flex align-items-center">Order Type</span>
              </button>
              <OrderTypeModal
                show={showordertypeModal}
                setshow={setShowordertypeModal}
                orderTypes={availableDeliveryTypes}
                availableDeliveryParties={availableDeliveryParties}
                selectedType={selectedDeliveryType}
                setSelected={handleDeliveryType}
                SelectedSubType={selectedParty}
                setSelectedSubItem={handleSelectedParty}
              />
              <NewTableModal
                show={modal10Show}
                onHide={() => setModal10Show(false)}
                modal10Show={modal10Show}
                setModal10Show={setModal10Show}
                orderDetails={orderDetails}
                setOrderDetails={setOrderDetails}
                selectedDeliveryType={selectedDeliveryType}
                selectedParty={selectedParty}
                selectedDeptTag={selectedDeptTag}
                selectTable={selectTable}
                setSelectTable={setSelectTable}
                tableId={tableId}
                setTableId={setTableId}
                guestSelected={guestSelected}
                setGuestSelected={setGuestSelected}
                buttonDisabled={buttonDisabled}
              />
            </div>
            {/* Branch select Dropdown*/}
            <div className="col mr-3  branch-select-container">
              {authUserInfo.details &&
                (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter") ? (
                  <Select
                    options={branchForSearch && branchForSearch}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={selectedBranch}
                    onChange={(branch) => handleSetBranch(branch)}
                    classNamePrefix="Branch"
                    className="table-text"
                    maxMenuHeight="200px"
                    placeholder="Branch"
                    styles={{
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                      control: (provided) => ({
                        ...provided,

                        borderRadius: ".5rem",
                        borderColor: "#27ccaa",
                        maxHeight: "2rem",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        color: "#27ccaa",
                      }),
                    }}
                  />
                ) : (
                  <div className="user_branch_name text-right">
                    {orderDetails?.branch?.name}{" "}
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <div className="col-12  mt-0 main-container-pos-wrapper" >

          {/* main container */}
          <div className="row pos--main-content-wrapper">
            <div
              className="col d-flex flex-column pt-0 p-3 pb-0 mb-0 pr-0 lef-side-pos-wrapper-container  "
            >
              {/* middle container header menu  */}
              {selectedDeptTag && Object.keys(availableFoodGroups).length &&
                <CategoryMenu
                  list={availableFoodGroups[selectedDeptTag.id]} 
                  onClick={handleFoodGroup}
                  setExpanded={setExpanded}
                  expanded={expanded}
                  setCatInOneLine={setCatInOneLine}
                  activeFoodGroup={activeFoodGroup}
                />
              }
              {/* middle container header search menu  */}
              <MenuHeader toggle={itemImage} settoggle={setItemImage}
                ref={inputSearch}
                value={searchInput}
                onChange={(e) => handleSearch(e)}
              />
              {/* middle container header  menu  */}
              {/* menu  */}
              <div
                className="col d-flex flex-row pl-0 pt-1 p-3 pr-0 pb-0 menu-listing-cont pos--menu-container row m-0 flex-grow-1"
              // data-simplebar
              >
                {/* <div className="pos--menu-container row m-0 flex-grow-1"> */}
                {/* <div className="col flex-grow-1 mh-100 p-1 pl-0"> */}
                {/* <div className="pos--menu-items-conatiner row m-0 flex-wrap"> */}
                {!searchedFoodItem?.searched ? (isMenuAvailable &&
                  <ItemListing
                    listing={menuForPos[orderDetails.branch.id][selectedDeptTag.id][activeFoodGroup]}
                    setExpanded={setExpanded}
                    expanded={expanded}
                    CatInOneLine={CatInOneLine}
                    config={{
                      orderDetails,
                      generalSettings,
                      selectedParty,
                      getSystemSettings,
                      handleFoodItemClicked,
                      flyStart,
                      animate,
                      buttonDisabled,
                      itemImage,
                    }}
                  />)
                  :
                  isMenuAvailable && (
                    <ItemListing
                      listing={searchedFoodItem?.list}
                      config={{
                        orderDetails,
                        generalSettings,
                        selectedParty,
                        getSystemSettings,
                        handleFoodItemClicked,
                        flyStart,
                        animate,
                        buttonDisabled,
                      }}
                    />)
                }
                {/* {!searchedFoodItem.searched
                        ? (menu && orderDetails.branch &&
                          selectedDeptTag && activeFoodGroup &&
                          menu[selectedDeptTag.id] &&
                          menu[selectedDeptTag.id][activeFoodGroup]
                          ? menu[selectedDeptTag.id][activeFoodGroup]?.map(
                            (foodItem) => (
                              <div
                                ref={flyStart}
                                key={foodItem.id}
                                title={foodItem?.item_description}
                                className={`font-weight-bold pos--menu-item rounded-05 mr-2 mb-2 
                                ${generalSettings && (selectedParty?.name.toLowerCase() !== "pre order") && parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
                                  (foodItem?.stock_qty <= 0 || foodItem?.stock_qty == undefined) && foodItem?.is_deal === 0 && !foodItem?.is_recipe && "disabled"}`}
                                onClick={(e) => {
                                  animate.current = true;
                                  flyStart.current = e.target;
                                  if (!buttonDisabled) {
                                    handleFoodItemClicked(foodItem, e)
                                  }
                                }}
                              >
                                <figure className="position-relative w-100">
                                  {generalSettings && (selectedParty?.name.toLowerCase() !== "pre order") &&
                                    parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && foodItem?.is_deal === 0 && !foodItem?.is_recipe && (
                                      foodItem?.stock_qty <= 0 || foodItem?.stock_qty == undefined ?
                                        <div className="position-absolute stockQty stock-bg-danger">
                                          Out of stock
                                        </div>
                                        :
                                        <div className="position-absolute stockQty stock-bg">
                                          Qty : {" " + foodItem?.stock_qty}
                                        </div>
                                    )
                                  }

                                  <img
                                    src={foodItem.image || defaultImg}
                                    alt=""
                                    className={`img-fluid item-img ${itemImage ? "d-none" : ""}`}
                                    loading="lazy"
                                  />
                                  <figcaption className={`item-name text-center px-2 ${itemImage ? "mt-4 mb-0" : "mt-2"}`}>
                                    {foodItem.name}
                                  </figcaption>
                                </figure>
                              </div>
                            )
                          )
                          : null)
                        : (menu && orderDetails.branch &&
                          selectedDeptTag && activeFoodGroup &&
                          menu[selectedDeptTag.id] &&
                          menu[selectedDeptTag.id][activeFoodGroup]
                          ? searchedFoodItem.list?.map((foodItem) => (
                            <div
                              ref={flyStart}
                              title={foodItem?.item_description}
                              key={foodItem.id}
                              className={`font-weight-bold pos--menu-item rounded-05 mr-2 mb-2 
                            ${generalSettings && (selectedParty?.name.toLowerCase() !== "pre order") && parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
                                (foodItem?.stock_qty <= 0 || foodItem?.stock_qty == undefined) && foodItem?.is_deal === 0 && !foodItem?.is_recipe && "disabled"}`}
                              onClick={(e) => {
                                if (!buttonDisabled) {
                                  handleFoodItemClicked(foodItem, e)
                                }
                              }}
                            >
                              <figure className="position-relative w-100">
                                {generalSettings && (selectedParty?.name.toLowerCase() !== "pre order") &&
                                  parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && foodItem?.is_deal === 0 && !foodItem?.is_recipe && (
                                    foodItem?.stock_qty <= 0 || foodItem?.stock_qty == undefined ?
                                      <div className="position-absolute stockQty stock-bg-danger">
                                        Out of stock
                                      </div>
                                      :
                                      <div className="position-absolute stockQty stock-bg">
                                        Qty : {" " + foodItem?.stock_qty}
                                      </div>
                                  )
                                }
                                <img
                                  src={foodItem.image || defaultImg}
                                  alt=""
                                  className={`img-fluid item-img ${itemImage ? "d-none" : ""}`}
                                  loading="lazy"
                                />
                                <figcaption className={`item-name text-center px-2 ${itemImage ? "mt-4 mb-0" : "mt-2"}`}>
                                  {foodItem.name}
                                </figcaption>
                              </figure>
                            </div>
                          ))
                          : null)} */}
                <ItemModal
                  closeModal={handleCloseItemModal}
                  showModal={showModal}
                  itemData={selectedFoodItem}
                  itemId={selectedFoodItemId}
                  addToCart={addToCart}
                  // tempQty={tempQty}
                  // setTempQty={setTempQty}
                  // selectGroup={selectGroup}
                  // setSelectGroup={setSelectGroup}
                  buttonDisabled={buttonDisabled}
                  menuWisePrice={menuWisePrice.current}
                  menuId={selectedDeptTag?.id}
                />
                {/* </div>
                  </div> */}
                {/* </div> */}
              </div>
            </div>

            {((parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 ? authUserInfo.details.user_type !== "call_center" : true) && (((newSettings && newSettings.workPeriod === null)) || workPeriodScreen == 0)) && (
              <div className="fk-overlay">
                <div className="fk-left-overlay__content text-center m-auto">
                  <h6
                    className={`text-primary text-uppercase ${authUserInfo.details &&
                      (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter") &&
                      "mb-0"
                      }`}
                  >
                    {workPeriodScreen == 1 ? authUserInfo.details &&
                      (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter")
                      ? _t(_t("Select branch to active POS"))
                      : _t(_t("start workperiod")) : _t(_t("Close previous workperiod"))}
                  </h6>
                  <div className="m-auto col-8 mt-3">
                    {authUserInfo.details &&
                      (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter") && (
                        <>
                          <Select
                            options={branchForSearch || []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={selectedBranch}
                            onChange={(branch) => handleSetBranch(branch)}
                            classNamePrefix="Branch"
                            className="table-text"
                            maxMenuHeight="200px"
                            placeholder="Branch"
                            styles={{
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none",
                              }),
                              control: (provided) => ({
                                ...provided,
                                borderRadius: ".5rem",
                                borderColor: "#27ccaa",
                                maxHeight: "2rem",
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                color: "#27ccaa",
                              }),
                            }}
                          />
                          <h4 className="mt-2 text-uppercase xsm-text mb-3">
                            {_t(_t("Start workperiod if it is not started"))}
                          </h4>
                        </>
                      )}
                  </div>
                  <NavLink
                    to="/dashboard/work-periods"
                    className="t-heading-font btn btn-success btn-sm text-uppercase sm-text submit-btn"
                  >
                    {_t(_t("Start Your Work Period"))}
                  </NavLink>
                </div>
              </div>
            )}


            {/* billing area   */}

            <div className="col-4 pt-2 py-1 pr-cart  billing-right-container">
              <div className="pos--bill-container rounded-25 pb-0 w-80 d-flex flex-column pb-2">
                <div className="cart-1">
                  {/* <div className="d-flex align-items-center justify-content-between bussines-day font-weight-md btn-primary rounded-top">
                    <div className="d-flex align-items-center justify-content-between mx-2">
                      <div>
                        Business Day: {newSettings?.workPeriod && newSettings.workPeriod?.date}
                      </div>
                    </div>
                    <button
                      disabled={buttonDisabled}
                      className=" btn btn-light xsm-text text-uppercase py-1 boxShadow-none"
                      style={{ borderRadius: "0 .25rem 0 0", borderBottom: "1px solid #dddddd" }}
                      onClick={(e) => setBackModal(true)}
                    >
                      Back
                    </button>
                  </div> */}
                  <h6 className="mb-0 font-weight-bold border-bottom d-flex justify-content-between p-2">
                    {selectedDeliveryType &&
                      `${selectedDeliveryType
                        ? selectedDeliveryType.name + " "
                        : ""
                      } - `}
                    {selectedParty ? selectedParty.name : ""}
                    <h6
                      className="m-0 ml-2 text-capitalize lg-text"
                    >
                      {orderDetails?.token
                        ? (getSystemSettings(generalSettings, "token_text") && getSystemSettings(generalSettings, "token_text")?.slice(0, 5)) + " # " + orderDetails.token.id
                        : ""}
                    </h6>
                  </h6>
                </div>

                <div className="flex-grow-1 container-fluid p-0">
                  <div className="ml-1 item_variation d-flex flex-row justify-content-between border-bottom bill-list">
                    <div className="text-capitalize d-inline-block fw-normal col-4">
                      Food Item
                    </div>
                    <div className="text-capitalize d-inline-block col-3 text-center ">
                      Qty
                    </div>
                    <div className="text-capitalize d-inline-block col-1 text-center ">
                      Dis %
                    </div>
                    <div className="text-capitalize d-inline-block col-1 text-center ">
                      Dis
                    </div>
                    <div className=" text-capitalize d-inline-block col-3 text-right">
                      Price
                    </div>
                  </div>
                  {/* <div className="simplebar-scrollbar"> */}
                  <div className="items-wrap ">
                    {cartItems && Object.keys(cartItems).length
                      ? Object.keys(cartItems)
                        .sort((a, b) =>
                          cartItems[a].seq < cartItems[b].seq ? 1 : -1
                        )
                        .map((itemHash) => {
                          return (
                            <div key={itemHash} ref={(e) => cardAnimate.current[itemHash] = e} className="cart-item-wrapper">
                              <CartItem
                                itemId={itemHash}
                                animate={animate}
                                item={cartItems[itemHash]}
                                deleteItem={deleteCartItem}
                                editItem={editCartItem}
                                addToCart={addToCart}
                                deleteOneCartItem={deleteOneCartItem}
                                commentFocus={commentFocus}
                                setAddReasonModalShowing={
                                  setAddReasonModalShowing
                                }
                                setAddFocItem={setAddFocItem}
                                handleSetItemQty={handleSetItemQty}
                                handleSetItemPrice={handleSetItemPrice}
                                handleSetItemDiscount={handleSetItemDiscount}
                                orderDetails={orderDetails}
                                deletedItemsOnEdit={deletedItemsOnEdit}
                                setCommentId={setCommentId}
                                userLock={userLock}
                                itemAdd={itemAdd}
                                authenticateStaffUser={authenticateStaffUser}
                                isOpenQty={parseInt(getSystemSettings(generalSettings, "open_qty_box")) === 1}
                                isLocked={isLocked}
                                getPrice={(p) =>
                                  roundOffPrice(
                                    p.after_tax_price ??
                                      getBeforeTaxPrice(
                                        calculatePriceForCartItem(p)
                                      )
                                  )
                                }
                              />
                            </div>
                          )
                        })
                      : null}

                    {cartItems && Object.keys(cartItems).length && commentId ? (
                      <InstructionModal
                        cartItems={cartItems}
                        updateItemImage={updateItemImage}
                        animate={animate}
                        commentId={commentId}
                        setCommentId={setCommentId}
                        updateComments={updateComments}
                      />
                    ) : null
                    }
                  </div>
                </div>
                {/* </div> */}

                <div className="col-12 p-0 m-0 t mt-10">
                  <div className="">
                    <div className="container-fluid">
                      <div className="row  border-bottom border-top align-items-center sub-tt">
                        {/*Subtotal*/}
                        <div className="col-6">
                          <div className=" d-flex flex-row justify-content-between">
                            <span className="text-capitalize sm-text d-inline-block total-bill">
                              SubTotal
                            </span>
                            <span className="text-capitalize sm-text d-inline-block font-weight-bold text-right mr-3">
                              {currencySymbolLeft()}
                              {cartSubTotal}
                              {currencySymbolRight()}
                            </span>
                          </div>
                        </div>
                        {/*Tax*/}
                        <div className="col-6">
                          <div className="d-flex flex-row justify-content-evenly align-items-center mr-2">
                            <span className="text-capitalize sm-text d-inline-block col-6 mr-1 position-relative">
                              Tax
                              <span className=" text-capitalize sm-text text-center font-weight-bold text-right ">
                                ({theTax && theTax + "%"})
                              </span>
                              {
                                parseInt(
                                  getSystemSettings(
                                    generalSettings,
                                    "payment_type_tax_calculation"
                                  )
                                ) === 1 && (
                                  <TiArrowSortedDown className="dashboard_card_down cursor-pointer" onClick={() => setPaymentTypeModalState({
                                    ...paymentTypeModalState,
                                    taxCalSelect: !paymentTypeModalState.taxCalSelect
                                  })} />
                                )
                              }
                              {paymentTypeModalState.taxCalSelect === true && (
                                <div className={`taxSelect 
                                  ${taxScroll.current?.actualHeight >=
                                    taxScroll.current?.overflowHeight ?
                                    "pr-1" : ""}`}
                                >
                                  {paymentTypeAvailable && paymentTypeAvailable?.map((groupItem, groupIndex) => {
                                    return (
                                      <span className="m-0 p-0" key={groupIndex} onClick={() => {
                                        handleTaxOnPaymentTypeChange(groupItem)
                                      }}>
                                        <li className={`list-unstyled dashboard_border p-1 cursor-pointer ${groupIndex == (paymentTypeAvailable?.length - 1) ? "mb-0" : "mb-1"}`}>{groupItem.name}</li>
                                      </span>
                                    )
                                  })
                                  }
                                </div>
                              )}
                            </span>
                            <span className="text-capitalize sm-text d-inline-block font-weight-bold col-6 text-right ml-3">
                              <>
                                {theTax &&
                                  currencySymbolLeft() +
                                  theVat +
                                  currencySymbolRight()}
                              </>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Input tags */}
                    <div className="input_fields  border-bottom  d-flex flex-row flex-wrap align-items-center justify-content-between py-0  px-2">
                      <div className="col-4 my-1 mx-1 d-flex align-items-center">
                        <label className="sm-text col-6 font-weight-bold mr-1">
                          Del Charge:
                        </label>
                        <input
                          disabled={deliveryInput.current}
                          className="form-control cartInput rounded-25"
                          type="number"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}
                          min="0"
                          value={deliveryCharges}
                          onChange={(e) => setDeliveryCharges(e.target.value)}
                        />
                      </div>
                      <div className="col my-1 mx-1">
                        <span className="sm-text text-center d-flex flex-row">
                          <span className=" font-weight-bold mr-1">
                            S.C(
                            {orderDetails?.branch &&
                              orderDetails.branch?.service_fees}
                            %):
                          </span>
                          <span> RS: {serviceCharges}</span>
                        </span>
                      </div>
                      <div className="col-4 my-1 mx-1 d-flex align-items-center">
                        <label className={`sm-text ${orderDetails.scheme.open_discount ? "col-6" : "col-6"} d-flex align-items-center font-weight-bold mr-1 text-center`}>
                          Dis:
                          {
                            orderDetails.scheme.open_discount ? (
                              <input
                                title="Discount percent"
                                className="ml-1 form-control cartInput rounded-25 p-2 "
                                type="number"
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                onWheel={(e) => e.target.blur()}
                                min="0"
                                max="100"
                                placeholder="%"
                                value={orderDetails.scheme.how_much_discount || ""}
                                onChange={(e) => hanldeDiscountPercent(cartSubTotal, e.target.value)}
                              />
                            ) : ""
                          }
                        </label>
                        <input
                          disabled={newOrder?.length === 0 || (orderDetails.scheme.open_discount ? orderDetails.scheme.how_much_discount : discountInput.current)}
                          className="form-control cartInput rounded-25 pr-1"
                          type="number"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}
                          min="0"
                          placeholder="Discount"
                          value={orderDetails.scheme.discount_amount}
                          onChange={(e) => {
                            const baseAmount = orderDetails.scheme?.discount_tax
                              ? (cartSubTotal + theVat) : cartSubTotal;
                            
                            if (parseFloat(e.target.value) > parseFloat(baseAmount)) {
                              toast.error(
                                `${_t(t("You can't type discount greater than bill amount"))}`,
                                toastObj
                              )
                            } else {
                              setOrderDetails({
                                ...orderDetails,
                                scheme: {
                                  ...orderDetails.scheme,
                                  discount_amount: e.target.value
                                }
                              });
                              calculateTax(cartSubTotal, e.target.value)
                            }
                          }
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-2 container-fluid">
                      <div className="row justify-content-between mb-1">
                        <div className="col-1 d-flex align-items-center">
                          {isLocked("offer_cp") &&
                            parseInt(
                              getSystemSettings(
                                generalSettings,
                                "offers_lock_status"
                              )
                            ) === 1 ? (
                            <div
                              className="cursor-pointer mx-1 d-flex align-items-center"
                              onClick={(e) => authenticateStaffUser("offer_cp")}
                            >
                              <FaLock className="lock_icon" />
                            </div>
                          ) : (
                            <div className="text-success mx-1 d-flex align-items-center">
                              <FaUnlock className="lock_icon" />

                            </div>
                          )}
                        </div>
                        <div className="col-5 ">
                          {tempSchemeForSearch !== null &&
                            tempSchemeForSearch?.length !== 0 ? (
                            <span className="position-relative offer-tip">
                              <span
                                className={`${isLocked("offer_cp") &&
                                  parseInt(
                                    getSystemSettings(
                                      generalSettings,
                                      "offers_lock_status"
                                    )
                                  ) === 1
                                  ? "tool-tip"
                                  : "disable-tip"
                                  }`}
                              >
                                please unlock offer
                              </span>
                              <Select
                                isDisabled={
                                  (isLocked("offer_cp") &&
                                    parseInt(
                                      getSystemSettings(
                                        generalSettings,
                                        "offers_lock_status"
                                      )
                                    ) === 1) || buttonDisabled ||
                                  (parseInt(getSystemSettings(generalSettings, "online_order_edit")) === 1 &&
                                  selectedParty?.name === "Website" && orderDetails?.is_edit)
                                }
                                isSearchable={true}
                                options={tempSchemeForSearch}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={
                                  orderDetails.scheme?.scheme_id
                                    ? schemeForSearchObj[
                                    orderDetails.scheme?.scheme_id
                                    ]
                                    : null
                                }
                                onChange={(offer) => handleSetOffer(offer)}
                                classNamePrefix="Offers"
                                className="table-text rounded-25 cursor-pointer"
                                menuPlacement="top"
                                maxMenuHeight="16rem"
                                placeholder="Offers"
                                styles={{
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                  control: (provided) => ({
                                    ...provided,
                                    borderRadius: ".3rem",
                                    borderColor: "#27ccaa",
                                    minHeight: "1.8rem",
                                    maxHeight: "2.2rem",
                                    marginTop: "0",
                                    marginBottom: "0",
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    fontSize: "1rem",
                                    color: "#27ccaa",
                                    padding: "0 5px 0 0",
                                    margin: "0",
                                    svg: {
                                      maxHeight: "2.2rem",
                                    },
                                  }),
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    padding: "0 5px",
                                    margin: "0",
                                    maxHeight: "2.2rem",
                                  }),
                                  inputContainer: (provided) => ({
                                    ...provided,
                                    margin: "0",
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    margin: "0",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }),
                                }}
                              />
                            </span>
                          ) : (
                            <span></span>
                          )}
                        </div>
                        <div className="col-6 d-flex justify-content-end print-cancel-row align-items-center">
                          <span className="mr-4 font-weight-bold bill-total">
                            Total Bill:
                          </span>
                          <span className="font-weight-bold mr-1 bill-total">
                            <>
                              {currencySymbolLeft()}
                              {cartTotal}
                              {currencySymbolRight()}
                            </>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="col-7 row">
                          <div className="mr-1 col-6">
                            {/* <button
                              type="button"
                              className="w-100 btn btn-success xsm-text text-uppercase col-3"
                            >
                              Print Bill
                            </button> */}
                          </div>

                          {/* <div className="col-4 m-0 p-0 cancel-btn">
                            <button
                              type="button"
                              className="w-100 btn btn-success2 xsm-text text-uppercase col-6"
                              onClick={emptyCard}
                            >
                              cancel
                            </button>
                          </div> */}
                        </div>
                      </div>

                      <div className="bill-last-row row mt-0 mb-0">
                        <div className={`d-flex justify-content-end col-12 `} style={{ padding: "0 1px 6px 12px", margin: "0px" }}>

                          {authUserInfo.permissions !== null &&
                            checkPermission(
                              authUserInfo.permissions,
                              "Settle"
                            ) ? (
                            !order_id &&
                              authUserInfo.details.user_type !== "call_center" ? (
                              <button
                                disabled={buttonDisabled || (selectedDeliveryType && selectedDeliveryType.name.match(/dine(.*)in/i) && !(parseInt(getSystemSettings(generalSettings, "enable_dinein_settle"))))}
                                type="button"
                                className="mr-2 w-15 btn btn-success3 d-flex align-items-center justify-content-center xsm-text text-uppercase col-6 rounded-25 font-weight-bold hover-effect"
                                onClick={handleSettleOrderButton}
                              >
                                <span>
                                  {!loading ? "settle" : "Please wait"}
                                </span>
                              </button>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}

                          {authUserInfo.permissions !== null &&
                            checkPermission(
                              authUserInfo.permissions,
                              "Submit"
                            ) ? (
                            <button
                              disabled={buttonDisabled}
                              type="button"
                              className="w-15 btn btn-primary xsm-text d-flex align-items-center justify-content-center text-uppercase col-6 rounded-25 font-weight-bold hover-effect mr-0"
                              onClick={(e) => {
                                if (!loading) {
                                  handleSubmitOrder(e)
                                }
                              }}
                            >
                              <span>

                                {!loading
                                  ? _t(_t("submit"))
                                  : _t(_t("Please wait"))}
                              </span>
                            </button>
                          ) : (
                            checkPermission(authUserInfo.permissions, "FOC Submit") &&
                            !order_id && authUserInfo.details.user_type !== "call_center" && (
                              <button
                                disabled={buttonDisabled}
                                type="button"
                                className="w-15 btn btn-primary xsm-text d-flex align-items-center justify-content-center text-uppercase col-6 rounded-25 font-weight-bold hover-effect mr-0"
                                onClick={(e) => {
                                  if (!loading) {
                                    handleFocConfirmation(e)
                                  }
                                }}
                              >
                                <span>

                                  {!loading
                                    ? _t(_t("Foc"))
                                    : _t(_t("Please wait"))}
                                </span>
                              </button>
                            ))}
                        </div>
                        <div className={`col-12 d-flex align-items-center bottom-righ-side-btns `} style={{ padding: "0px 0px 0px 5px", margin: "0px", gap: "6px" }}>

                          {authUserInfo?.details.user_type === "call_center" && (
                            <>
                              <div
                                aria-label="payment Type"
                                className="indolj-switcher-container mx-1 cart-payments-switchters"
                              >
                                {paymentOptions.map((paymentOption) =>
                                (
                                  <div
                                    className={`switch ${callCenterPayment?.payment_type == paymentOption
                                      ? "active-switch"
                                      : ""
                                      }`}
                                    key={paymentOption}
                                    ref={(e) =>
                                      callCenterPayment?.payment_type == paymentOption
                                        ? currentNavPill(e)
                                        : null
                                    }
                                    onClick={() =>
                                      handlePaymentType(paymentOption)
                                    }
                                  >
                                    {paymentOption}
                                  </div>
                                )
                                )}
                                <div className="driveActive"></div>
                              </div>
                            </>
                          )}
                          {/* <div className=" ml-1 fk-calculator-container calculator-btn "> */}
                          {
                            /*
                            <button
                              className="fa fa-calculator btn btn-info text-uppercase w-100 h-1000 rounded-25"
                              onClick={() => setCalculatorMenu(!calculatorMenu)}
                            ></button>
                            <div
                              className={`calculator ${
                                calculatorMenu && "active"
                              }`}
                            >
                              <Calculator />
                            </div>
                          */
                          }
                          {/* <button
                            title="Rider Note"
                            disabled={buttonDisabled}
                            className="btn btn-primary xsm-text text-uppercase rounded-25 d-flex align-items-center py-1 px-2"
                            onClick={(e) =>
                              newOrder && newOrder.length > 0
                                ? setNoteRiderModal(true)
                                : toast.error("Please select item first")
                            }
                          >
                            <img src="/assets/img/writing.png" style={{ height: "1.25rem" }} alt="" />
                          </button> */}
                          <POSCardDropdown 
                            newOrder={newOrder}
                            setOrderDetails= {setOrderDetails}
                            setNoteRiderModal={setNoteRiderModal}
                            handleSubmitOrder={handleSubmitOrder}
                            buttonDisabled={buttonDisabled}
                          />
                          <button
                            disabled={buttonDisabled}
                            className=" btn btn-primary btn-light xsm-text text-uppercase py-1 boxShadow-none back-to-the-pos"
                            onClick={(e) => setBackModal(true)}
                          >
                            <span>
                              Back
                            </span>
                          </button>
                          {authUserInfo.permissions !== null &&
                            checkPermission(
                              authUserInfo.permissions,
                              "Submit"
                            ) ? (
                            <>
                              {/* {authUserInfo.details.user_type !== "call_center" && (
                                <button
                                  disabled={buttonDisabled || order_id}
                                  type="button"
                                  style={{ backgroundColor: "#DE4646" }}
                                  className="ml-1 btn btn-danger xsm-text d-flex align-items-center justify-content-center text-uppercase px-2 rounded-25 font-weight-bold hover-effect"
                                  onClick={(e) => {
                                    if (!loading) {
                                      handleSubmitOrder(e, 1)
                                    }
                                  }}
                                >
                                  <span>

                                    {!loading ?
                                      _t(_t("hold"))
                                      : _t(_t("Please wait"))}
                                  </span>
                                </button>
                              )} */}
                              {/* <div className="ml-1 d-flex justify-content-start"> */}
                              <button
                                disabled={buttonDisabled || selectedParty?.name.toLowerCase() !== "pre order"}
                                className="font-weight-bold btn btn-success xsm-text text-uppercase rounded-25 px-2"
                                onClick={(e) => handlePreOrderConfirmation(e)}
                              >
                                <span>
                                  Pre Od
                                </span>
                              </button>
                              {/* </div> */}
                            </>
                          ) : (
                            ""
                          )}
                          {
                            navigator.onLine && authUserInfo.details.user_type !== "call_center" && (
                              <button
                                disabled={buttonDisabled || syncOrder}
                                type="button"
                                className="mx-1 btn btn-secondary xsm-text d-flex align-items-center justify-content-center text-uppercase px-2 rounded-25 font-weight-bold hover-effect"
                                onClick={(e) => {
                                  e.preventDefault()
                                  if(!syncOrder) {
                                    syncLocalOrders("sync")
                                  }
                                }}
                              >
                                <span>
                                  Sync
                                </span>
                              </button>
                            )
                          }
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SettleOrder
        managerId={managerId}
        showSettle={showSettle}
        setSelectedKot={setSelectedKot}
        setShowSettle={setShowSettle}
        selectedDeptTag={selectedDeptTag}
        selectedParty={selectedParty}
        selectedDeliveryType={selectedDeliveryType}
        buttonDisabled={buttonDisabled}
        setButtonDisabled={setButtonDisabled}
        newOrder={newOrder}
        cartItems={cartItems}
        setCartItems={setCartItems}
        cartTotal={cartTotal}
        selectedBranch={selectedBranch}
        orderDetails={orderDetails}
        setOrderDetails={setOrderDetails}
        deliveryCharges={deliveryCharges}
        showPriceOfEachOrderItem={(p) =>
          roundOffPrice(
            p.after_tax_price ?? getBeforeTaxPrice(calculatePriceForCartItem(p))
          )
        }
        theVatSettle={theVatSettle}
        setTheVatSettle={setTheVatSettle}
        setPaidMoney={setPaidMoney}
        setNewSettings={setNewSettings}
        newSettings={newSettings}
        totalsettle={totalsettle}
        setTotalSettle={setTotalSettle}
        paidMoney={paidMoney}
        serviceCharges={serviceCharges}
        foodItem={foodItem}
        setFoodItem={setFoodItem}
        cartSubTotal={cartSubTotal}
        loyaltyPoint={loyaltyPoint}
        setloyaltyPoint={setloyaltyPoint}
        emptyCardOnChange={emptyCardOnChange}
        tokenNumber={tokenNumber}
        theVat={theVat}
        theTax={theTax}
        setTheVat={setTheVat}
        returnMoneyUsd={returnMoneyUsd}
        setReturnMoneyUsd={setReturnMoneyUsd}
        isSettle={isSettle}
        getPrice={(p) => roundOffPrice(getBeforeTaxPrice(p))}
        handleLocalPrint={handleLocalPrint}
        handleReceiptPrint={handleReceiptPrint}
        handleKotItems={handleKotItems}
        paymentTypeAvailable={paymentTypeAvailable}
        fbrInvoiceNum={fbrInvoiceNum}
        srbInvoiceNum={srbInvoiceNum}
        token_No={token_No}
        setModal9Show={setModal9Show}
      />

      <OrderPrint
        token_No={token_No}
        newOrder={newOrder}
        foodGroupsToPrint={foodGroupsToPrint}
        selectedKot={selectedKot}
        cartSubTotal={cartSubTotal}
        cartTotal={cartTotal}
        newSettings={newSettings}
        loyaltyPoint={loyaltyPoint}
        con_Kot={con_Kot}
        totalSettle={totalsettle}
        theVat={theVat}
        theVatSettle={theVatSettle}
        paidMoney={paidMoney}
        orderDetails={orderDetails}
        taxType={taxType}
        returnMoneyUsd={returnMoneyUsd}
        isSettle={isSettle.current}
        srbInvoiceNum={srbInvoiceNum.current}
        fbrInvoiceNum={fbrInvoiceNum.current}
        serviceCharges={serviceCharges}
        deliveryCharges={deliveryCharges}
        selectedDeliveryType={selectedDeliveryType}
        selectedParty={selectedParty}
        selectedDeptTag={selectedDeptTag}
        customerPrint={componentRef}
        component2Ref={component2Ref}
        barcodePrintRef={barcodePrintRef}
      />

      {/* Authenticate Modal */}
      {showPasswordPopup ? (
        <PasscodeAuthenticator
          correctPasscode={authUserInfo.details.user_passcode}
          managerPass={managerPasscode}
          setComponentUnlock={setComponentUnlock}
          setManagerId={setManagerId}
          thisComponent={componentUnlock}
          onSuccess={onSuccessAuthenticationStaff}
          show={showPasswordPopup}
          hanleCancelAuthenticate={hanleCancelAuthenticate}
        />
      ) : null}

      <PosModal
        handleCardSubmit={handleCardSubmit}
        setOrderDetails={setOrderDetails}
        orderDetails={orderDetails}
        paymentTypeAvailable={paymentTypeAvailable}
        cardModal={cardModal}
        backModal={backModal}
        setBackModal={setBackModal}
        emptyCard={emptyCard}
        cashDetails={cashDetails}
        setCashDetails={setCashDetails}
        noteRiderModal={noteRiderModal}
        handleSubmitOrder={handleSubmitOrder}
        setNoteRiderModal={setNoteRiderModal}
        handlePreOrder={handlePreOrder}
        handlePunchOrder={handlePunchOrder}
      />
      <CustomPosModal
        addReasonOnSubmit={addReasonOnSubmit}
        setAddReasonModalShowing={setAddReasonModalShowing}
        addReasonModalShowing={addReasonModalShowing}
        addFocItem = {addFocItem}
        setAddFocItem = {setAddFocItem}
        handleFocItem = {handleFocItem}
        deleteReason={deleteReason}
        setDeleteReason={setDeleteReason}
        setPaymentTypeModalState={setPaymentTypeModalState}
        paymentTypeModalState={paymentTypeModalState}
        callCenterPayment={callCenterPayment}
        setCallCenterPayment={setCallCenterPayment}

      />
      {/* beep sound */}


    </>
  );
}

export default NewPos;
